package one.primehealth.app

import kotlinx.coroutines.channels.BufferOverflow
import kotlinx.coroutines.channels.Channel

class AppRestartController {

    val channel = Channel<Unit>(
        capacity = Channel.RENDEZVOUS,
        onBufferOverflow = BufferOverflow.SUSPEND,
    )

    suspend fun restart() {
        channel.send(Unit)
    }
}